import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react";
import API from "../../config/config";
import { toast } from "react-toastify";

const StepProfilePhoto = forwardRef(
  ({ driver, formData, setFormData, disabled }, ref) => {
    console.log("In Profile Driver", driver);
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(formData.profilePhoto || null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (formData.profilePhoto) {
        setPreviewUrl(formData.profilePhoto);
      }
    }, [formData.profilePhoto]);

    const uploadPhoto = async () => {
      if (!file) return null;

      const token = localStorage.getItem("adminToken");
      const formdata = new FormData();
      formdata.append("type", "profilepic");
      formdata.append("ownerId", driver._id);
      formdata.append("documentFor", "Driver");
      formdata.append("file", file);

      const response = await fetch(API.ADMIN.ADMINDOCUMENT_UPLOAD, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formdata,
      });

      const result = await response.json();
      if (response.ok) {
        return result.document?.documentUrl;
      } else {
        throw new Error(result.message || "Upload failed");
      }
    };

    useImperativeHandle(ref, () => ({
      validateAndUpload: async () => {
        // Check if profile photo is provided
        if (!file && !formData.profilePhoto) {
          toast.error("Please upload a profile photo.");
          throw new Error("Please upload a profile photo.");
        }

        setLoading(true);
        try {
          // If there's a new file to upload
          if (file) {
            const url = await uploadPhoto();
            if (url) {
              setFormData((prev) => ({ ...prev, profilePhoto: url }));
              setPreviewUrl(url);
              toast.success("Profile photo updated successfully.");
            }
            return url;
          }
          // If using existing photo
          return formData.profilePhoto;
        } finally {
          setLoading(false);
        }
      },
    }));

    const handleFileChange = (e) => {
      const selected = e.target.files[0];
      setFile(selected);

      if (selected) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewUrl(reader.result);
          setFormData((prev) => ({ ...prev, profilePhoto: reader.result }));
        };
        reader.readAsDataURL(selected);
      } else {
        setPreviewUrl(null);
        setFormData((prev) => ({ ...prev, profilePhoto: null }));
      }
    };

    return (
      <div className="max-w-2xl mx-auto p-4 bg-white rounded shadow text-sm">
        <label className="block mb-1 font-medium text-sm text-gray-700">
          Upload Profile Photo <span className="text-red-500">*</span>
        </label>
        <input
          type="file"
          name="profilePhoto"
          accept="image/*"
          onChange={handleFileChange}
          className="block w-full border px-2 py-1 rounded text-sm mb-3"
          disabled={loading || disabled}
        />
        {loading && (
          <div className="text-center mb-3 text-blue-600 font-semibold">
            Uploading...
          </div>
        )}
        {previewUrl && (
          <div className="mb-3 flex justify-center">
            <img
              src={previewUrl}
              alt="Preview"
              className="w-24 h-24 object-cover rounded-full border"
            />
          </div>
        )}
      </div>
    );
  }
);

export default StepProfilePhoto;
